function n(n){return !n||0===n}

export { n as isZero };
//# sourceMappingURL=isZero.js.map
